var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('announcing-tooltip',{attrs:{"text":(_vm.prefix + " - " + _vm.tooltipText),"prefix":_vm.prefix}},[_c('i',{class:['fa-regular', 'fa-circle-question', 'not-set-icon', _vm.sizeClass],attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }